import { useDistanceToNow } from '@/hooks';
import { ClockIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
type DateCounterProps = {
  date: string;
  className?: string;
};
export const DateCounter = ({
  date,
  className
}: DateCounterProps) => {
  const distanceToNow = useDistanceToNow();
  return <div className={cn('flex items-center gap-2xs text-neutral', className)} data-sentry-component="DateCounter" data-sentry-source-file="DateCounter.tsx">
      <ClockIcon size="xs" className="hidden tablet-sm:block" data-sentry-element="ClockIcon" data-sentry-source-file="DateCounter.tsx" />
      <ClockIcon size="2xs" className="tablet-sm:hidden" data-sentry-element="ClockIcon" data-sentry-source-file="DateCounter.tsx" />
      <span>{distanceToNow(date)}</span>
    </div>;
};